import { Gym, ILiveStreamOptions } from 'fitbeat.models';
import { WorkoutType } from '../../config';
import { WorkoutSettings } from '../../entities/user';
import { SessionSequenceEntry } from './sessionsequenceentry';

export class HomeWorkoutSequence {
  public workoutId: string;
  public startTime: Date;
  public startTimeOfFirstExercise: Date;
  public endTime: Date;
  public originalEndTime?: Date;
  public sequences: SessionSequenceEntry[];
  public workoutSettings: WorkoutSettings;
  public gym: Gym;
  public isInstantBooking: boolean;
  public isDemoBooking?: boolean;
  public groupCallPairedId?: string;
  public homeWorkoutStartedAt?: Date;
  public workoutType: WorkoutType;
  public mediaCdnConfiguration: {
    baseUrl: string,
    queryParamatersToAppend: string,
  };
  public workoutDurationInMs: number;
  public isStreamingWorkout?: boolean;
  public pairedSessionReference?: string;
  public pairedSessionUserProfileId?: string;
  public enableInstructorChange: boolean;
  public livestreamOptions?: ILiveStreamOptions;

  constructor(
    startTime: Date,
    endTime: Date,
    sequences: SessionSequenceEntry[],
    workoutId: string,
    workoutSettings: WorkoutSettings,
    workoutType: WorkoutType,
    gym: Gym,
    startTimeOfFirstExercise: Date,
    isInstantBooking: boolean,
    workoutDurationInMs: number,
    isDemoBooking?: boolean,
    groupCallPairedId?: string,
    originalEndTime?: Date,
    homeWorkoutStartedAt?: Date,
    isStreamingWorkout?: boolean,
    pairedSessionReference?: string,
    pairedSessionUserProfileId?: string,
    enableInstructorChange: boolean = false,
    livestreamOptions?: ILiveStreamOptions,
  ) {
    this.startTime = startTime;
    this.endTime = endTime;
    this.originalEndTime = originalEndTime;
    this.sequences = sequences;
    this.workoutId = workoutId,
    this.workoutSettings = workoutSettings;
    this.workoutType = workoutType;
    this.gym = gym;
    this.startTimeOfFirstExercise = startTimeOfFirstExercise;
    this.isInstantBooking = isInstantBooking;
    this.isDemoBooking = isDemoBooking;
    this.groupCallPairedId = groupCallPairedId;
    this.homeWorkoutStartedAt = homeWorkoutStartedAt;
    this.workoutDurationInMs = workoutDurationInMs;
    this.isStreamingWorkout = isStreamingWorkout;
    this.pairedSessionReference = pairedSessionReference;
    this.pairedSessionUserProfileId = pairedSessionUserProfileId;
    this.enableInstructorChange = enableInstructorChange;
    this.livestreamOptions = livestreamOptions;
  }
}
